import {styled} from '@mui/material/styles';

// A div that flips cursor between pointer and default via the $isClickable prop.
export const CursorBox = styled('div')<{$isClickable: boolean}>`
  cursor: ${p => (p.$isClickable ? 'pointer' : 'default')};
`;
CursorBox.displayName = 'S.CursorBox';
